import { Outlet } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { SurveysPageProvider } from 'pages/surveys/context/surveysPageContext'

export const SurveysPageLayout = observer(() => (
  <SurveysPageProvider>
    <Outlet />
  </SurveysPageProvider>
))
